import React from 'react';
import type { SanityBlock } from '@sanity/client';
import { InfoBox } from '@naf-simba/sections-info-box';
import BlockContent from '../../../BlockContent';

export interface InfoBoxSerializerProps {
  value: {
    displayOption?: 'standard' | 'green' | null;
    highlightedText: string;
    title: string;
    text: SanityBlock[];
  };
}

export const InfoBoxBlock = ({ value }: InfoBoxSerializerProps) => (
  <InfoBox
    displayColor={value.displayOption || 'standard'}
    highlightedText={value.highlightedText}
    title={value.title}
    content={<BlockContent value={value.text} />}
  />
);
